import { useQuery } from '@tanstack/react-query';
import type { AgentApiTeamsIndex } from '@/types/serializers';

export default function useFetchTeams() {
  return useQuery({
    queryKey: ['/agent/api/teams'],
    queryFn: async () => {
      const response = await fetch('/agent/api/teams.json');
      const data: AgentApiTeamsIndex = await response.json();
      return data;
    },
  });
}
